import { ReactNode } from 'react';
import { alpha, Box, ButtonBase, Typography } from '@mui/material';
import { CheckCircle } from '@mui/icons-material';

interface SelectableCardProps {
  selected: boolean;
  onClick: () => void;
  title: ReactNode;
  icon?: ReactNode;
  description?: ReactNode;
  disabled?: boolean;
}

// Delat valbart kort (typ av utskick, typ av evenemang m.m.). Mjuk stil: grå border, grön vid val, fin hover.
export const SelectableCard = ({ selected, onClick, title, icon, description, disabled }: SelectableCardProps) => (
  <ButtonBase
    onClick={onClick}
    disabled={disabled}
    sx={{
      width: '100%',
      height: '100%',
      py: 3,
      px: 2,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      gap: 1,
      textAlign: 'center',
      borderRadius: 1.5,
      border: '2px solid',
      borderColor: selected ? 'success.main' : 'divider',
      backgroundColor: (theme) => (selected ? alpha(theme.palette.success.light, 0.2) : '#fff'),
      position: 'relative',
      transition: 'border-color .15s, background-color .15s',
      '&:hover': {
        borderColor: 'success.main',
        backgroundColor: (theme) => alpha(theme.palette.success.light, 0.12),
      },
    }}
  >
    {icon && (
      <Box sx={{ display: 'flex', color: selected ? 'success.main' : 'primary.main', opacity: 0.9, '& .MuiSvgIcon-root': { fontSize: '2.4rem' } }}>
        {icon}
      </Box>
    )}
    <Typography variant='body1' component='div' sx={{ fontWeight: 500 }}>
      {title}
    </Typography>
    {description && (
      <Typography variant='body2' component='div' color='text.secondary'>
        {description}
      </Typography>
    )}
    {selected && <CheckCircle sx={{ position: 'absolute', top: 8, right: 8, fontSize: 20, color: 'success.main' }} />}
  </ButtonBase>
);
